/**
 * ALOHA PLATFORM
 * Copyright © 2025 Malcolm KH Lee III. All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (non-critical)
const resizeObserverLoopErr = /^[^(ResizeObserver loop limit exceeded)]/;
const consoleError = console.error;
console.error = (...args) => {
  if (resizeObserverLoopErr.test(args[0])) {
    return;
  }
  consoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
